export default "__VITE_ASSET__CHxlfloP__"